import 'regenerator-runtime/runtime';
import 'react-toastify/dist/ReactToastify.css';
import React, { FC, useEffect } from 'react';
import useVersionCheck from 'core/useVersionCheck';
import { ThemeProvider } from 'styled-components';
import theme from 'styles/theme';
import GlobalStyles from 'styles/globalStyles';
import { ToastContainer } from 'react-toastify';
import ApiErrorListener from 'core/ApiErrorListener';
import Router from 'routes';

const App: FC = () => {
  useVersionCheck();

  return (
    <div data-testid="app">
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Router />
        <ToastContainer />
        <ApiErrorListener />
      </ThemeProvider>
    </div>
  );
};

export default App;
